import { render } from "./toolbox.vue?vue&type=template&id=3ce1d354&scoped=true"
import script from "./toolbox.vue?vue&type=script&lang=js"
export * from "./toolbox.vue?vue&type=script&lang=js"

import "./toolbox.vue?vue&type=style&index=0&id=3ce1d354&lang=scss&scoped=true"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce1d354"]])

export default __exports__